module.exports = __webpack_public_path__ + "static/hadoop-931c6236bfa9fc3131ecab3d993694ba.svg";